import cn from 'classnames';

import Icon from 'components/generic/Icon.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './StepIndicator.module.scss';

const STEPS = [
  { key: 1, labelKey: 'register.stepIndicator.personalInfo' },
  { key: 2, labelKey: 'register.stepIndicator.businessType' },
  { key: 3, labelKey: 'register.stepIndicator.businessInfo' },
];

export const StepIndicator = ({ currentStep }) => {
  const { t } = useTranslation();

  return (
    <div data-bem="StepIndicator" className={CN.component}>
      {STEPS.map(({ key, labelKey }) => {
        const isCompleted = key < currentStep;
        const isActive = key === currentStep;

        return (
          <div
            key={key}
            className={cn(CN.step, {
              [CN.active]: isActive,
              [CN.completed]: isCompleted,
            })}
          >
            <span className={CN.indicator}>{isCompleted ? <Icon variant="tickCircleWhite" width="xs" isCentered /> : key}</span>
            <span className={CN.label}>{t(labelKey)}</span>
          </div>
        );
      })}
    </div>
  );
};
